import { combineReducers } from "redux";
import getAdmin from "./adminPanel";
import getManager from "./managerPanel";
import getPromocodes from "./promocodes";
import getApplyPromocodes from "./applyPromocodes";

const AdminReducer = combineReducers({ getAdmin, getManager, getPromocodes, getApplyPromocodes });

export default AdminReducer;